import { useState } from "react";
import { useNavigate } from "react-router-dom";
const NAV_LINKS = ["Home", "Services", "Plans", "How It Works", "Contact"];

const SERVICES = [
  {
    icon: "⚡",
    title: "Quick Wash",
    desc: "Fast exterior rinse, foam wash, and wipe-down. Perfect for a quick refresh on the go.",
    time: "20–30 min",
    color: "#3B82F6",
  },
  {
    icon: "✨",
    title: "Deep Clean",
    desc: "Full interior vacuuming, dashboard wipe, exterior foam wash, tyre dressing & more.",
    time: "60–90 min",
    color: "#8B5CF6",
  },
  {
    icon: "💎",
    title: "Premium Detail",
    desc: "Complete detailing — clay bar, polishing, waxing, interior steam clean & odour removal.",
    time: "3–4 hrs",
    color: "#EC4899",
  },
  {
    icon: "🪟",
    title: "Glass & Tyre Care",
    desc: "Streak-free glass cleaning inside & out, tyre shine, and rim deep clean.",
    time: "30–45 min",
    color: "#F59E0B",
  },
];

const PLANS = [
  {
    name: "On Demand",
    icon: "🎯",
    badge: null,
    price: "₹299",
    unit: "per wash",
    features: [
      "Book any time",
      "Quick or Deep service",
      "No commitment",
      "Real-time tracking",
    ],
    color: "#3B82F6",
    bg: "#EFF6FF",
  },
  {
    name: "Monthly 4×",
    icon: "🔄",
    badge: "Most Popular",
    price: "₹999",
    unit: "per month",
    features: [
      "4 washes / month",
      "Priority booking",
      "Any service type",
      "Save up to 17%",
    ],
    color: "#8B5CF6",
    bg: "#F5F3FF",
  },
  {
    name: "Monthly 2×",
    icon: "📅",
    badge: null,
    price: "₹599",
    unit: "per month",
    features: [
      "2 washes / month",
      "Flexible scheduling",
      "Any service type",
      "Save up to 10%",
    ],
    color: "#10B981",
    bg: "#ECFDF5",
  },
  {
    name: "Weekly Plan",
    icon: "🏆",
    badge: "Best Value",
    price: "₹1,799",
    unit: "per month",
    features: [
      "Weekly washes",
      "Dedicated washer",
      "Premium services included",
      "Save up to 25%",
    ],
    color: "#F59E0B",
    bg: "#FFFBEB",
  },
];

const STEPS = [
  {
    step: "01",
    title: "Download the App",
    desc: "Available on Google Play Store & Apple App Store. Install in seconds.",
    icon: "📱",
  },
  {
    step: "02",
    title: "Register & Add Vehicle",
    desc: "Create your account, add your car details and preferred location.",
    icon: "🚗",
  },
  {
    step: "03",
    title: "Choose Your Plan",
    desc: "Pick on-demand or a subscription plan that suits your needs.",
    icon: "📋",
  },
  {
    step: "04",
    title: "Book a Wash",
    desc: "Select service type, date & time. Our pro arrives at your doorstep.",
    icon: "📍",
  },
  {
    step: "05",
    title: "Sit Back & Relax",
    desc: "Track your washer in real-time. Receive quality wash at your location.",
    icon: "✅",
  },
];

const TESTIMONIALS = [
  {
    name: "Rahul M.",
    city: "Ahmedabad",
    rating: 5,
    text: "Amazing service! The deep clean transformed my car. Book via app in under a minute.",
  },
  {
    name: "Priya S.",
    city: "Surat",
    rating: 5,
    text: "Monthly 4× plan is perfect for me. Always on time and very professional.",
  },
  {
    name: "Karan P.",
    city: "Vadodara",
    rating: 4,
    text: "Quick service lives up to its name. 25 mins and the car shines. Love it!",
  },
];

export default function CarWash() {
  const navigate = useNavigate();
  const [showDeleteInfo, setShowDeleteInfo] = useState(false);
  const handleDeleteClick = () => {
    setShowDeleteInfo(true);
  };
  const [activeNav, setActiveNav] = useState("Home");
  const [menuOpen, setMenuOpen] = useState(false);
  const scrollTo = (id) => {
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
    setMenuOpen(false);
    setShowDeleteInfo(false);
  };

  return (
    <div
      style={{
        fontFamily: "'Segoe UI', sans-serif",
        color: "#1E293B",
        overflowX: "hidden",
      }}
    >
      {/* ── NAV ── */}
      <nav
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          zIndex: 100,
          background: "rgba(255,255,255,0.95)",
          backdropFilter: "blur(12px)",
          boxShadow: "0 1px 20px rgba(0,0,0,0.08)",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          padding: "0 5%",
          height: 68,
        }}
      >
        <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
          <div
            style={{
              width: 40,
              height: 40,
              borderRadius: 10,
              background: "linear-gradient(135deg,#3B82F6,#8B5CF6)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontSize: 20,
            }}
          >
            🚿
          </div>
          <span
            style={{
              fontWeight: 800,
              fontSize: 20,
              background: "linear-gradient(135deg,#3B82F6,#8B5CF6)",
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent",
            }}
          >
            ShineDrive
          </span>
        </div>

        {/* Desktop Links */}
        <div
          style={{ display: "flex", gap: 32, alignItems: "center" }}
          className="desktop-nav"
        >
          {NAV_LINKS.map((l) => (
            <span
              key={l}
              onClick={() => scrollTo(l.toLowerCase().replace(" ", "-"))}
              style={{
                cursor: "pointer",
                fontWeight: 600,
                fontSize: 14,
                color: activeNav === l ? "#3B82F6" : "#475569",
                transition: "color .2s",
              }}
              onMouseEnter={(e) => (e.target.style.color = "#3B82F6")}
              onMouseLeave={(e) =>
                (e.target.style.color = activeNav === l ? "#3B82F6" : "#475569")
              }
            >
              {l}
            </span>
          ))}
        </div>

        <button
          onClick={() => scrollTo("plans")}
          style={{
            background: "linear-gradient(135deg,#3B82F6,#8B5CF6)",
            color: "#fff",
            border: "none",
            padding: "10px 24px",
            borderRadius: 50,
            fontWeight: 700,
            cursor: "pointer",
            fontSize: 14,
            boxShadow: "0 4px 15px rgba(59,130,246,.35)",
          }}
        >
          Get Started
        </button>
      </nav>

      {/* ── HERO ── */}
      <section
        id="home"
        style={{
          minHeight: "100vh",
          paddingTop: 68,
          background:
            "linear-gradient(135deg, #EFF6FF 0%, #F5F3FF 50%, #FDF4FF 100%)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          textAlign: "center",
          padding: "100px 5% 60px",
          position: "relative",
          overflow: "hidden",
        }}
      >
        {/* decorative circles */}
        {[
          { size: 400, top: -80, left: -100, color: "rgba(59,130,246,0.08)" },
          {
            size: 300,
            bottom: -60,
            right: -80,
            color: "rgba(139,92,246,0.08)",
          },
        ].map((c, i) => (
          <div
            key={i}
            style={{
              position: "absolute",
              width: c.size,
              height: c.size,
              borderRadius: "50%",
              background: c.color,
              top: c.top,
              left: c.left,
              bottom: c.bottom,
              right: c.right,
            }}
          />
        ))}

        <div style={{ maxWidth: 760, position: "relative" }}>
          <div
            style={{
              display: "inline-flex",
              alignItems: "center",
              gap: 8,
              background: "#fff",
              borderRadius: 50,
              padding: "8px 20px",
              boxShadow: "0 2px 12px rgba(0,0,0,0.08)",
              marginBottom: 28,
              fontSize: 13,
              fontWeight: 600,
              color: "#3B82F6",
            }}
          >
            <span>🚗</span> Doorstep Car Wash — At Your Location
          </div>

          <h1
            style={{
              fontSize: "clamp(38px,6vw,72px)",
              fontWeight: 900,
              lineHeight: 1.1,
              marginBottom: 24,
            }}
          >
            Your Car Deserves
            <br />
            <span
              style={{
                background: "linear-gradient(135deg,#3B82F6,#8B5CF6)",
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
              }}
            >
              a Spotless Shine
            </span>
          </h1>

          <p
            style={{
              fontSize: 18,
              color: "#64748B",
              lineHeight: 1.7,
              marginBottom: 40,
              maxWidth: 560,
              margin: "0 auto 40px",
            }}
          >
            Professional car wash services at your doorstep. Book in seconds,
            track in real-time, and enjoy a sparkling clean car — without
            leaving home.
          </p>

          <div
            style={{
              display: "flex",
              gap: 16,
              justifyContent: "center",
              flexWrap: "wrap",
              marginBottom: 56,
            }}
          >
            <StoreButton store="google" />
            <StoreButton store="apple" />
          </div>

          <div
            style={{
              display: "flex",
              gap: 40,
              justifyContent: "center",
              flexWrap: "wrap",
            }}
          >
            {[
              ["10,000+", "Cars Washed"],
              ["4.8★", "App Rating"],
              ["500+", "Cities Covered"],
            ].map(([val, lbl]) => (
              <div key={lbl} style={{ textAlign: "center" }}>
                <div
                  style={{ fontSize: 28, fontWeight: 800, color: "#1E293B" }}
                >
                  {val}
                </div>
                <div
                  style={{ fontSize: 13, color: "#94A3B8", fontWeight: 600 }}
                >
                  {lbl}
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* floating car card */}
        {/* <div style={{
          position: "absolute", right: "5%", top: "50%", transform: "translateY(-50%)",
          background: "#fff", borderRadius: 20, padding: 24, boxShadow: "0 20px 60px rgba(0,0,0,0.12)",
          width: 200, display: window.innerWidth > 1100 ? "block" : "none",
        }}>
          <div style={{ fontSize: 48, textAlign: "center", marginBottom: 12 }}>🚗</div>
          <div style={{ textAlign: "center", fontWeight: 700, marginBottom: 4 }}>Quick Wash</div>
          <div style={{ textAlign: "center", color: "#64748B", fontSize: 12, marginBottom: 12 }}>Arriving in 20 min</div>
          <div style={{ background: "#DCFCE7", borderRadius: 8, padding: "6px 12px", textAlign: "center", color: "#16A34A", fontWeight: 700, fontSize: 13 }}>✓ On the way</div>
        </div> */}
      </section>

      {/* ── SERVICES ── */}
      <section
        id="services"
        style={{ padding: "100px 5%", background: "#fff" }}
      >
        <SectionHeader
          label="Our Services"
          title="Pick the Right Wash for Your Car"
          sub="From a quick rinse to a full detail — we've got every level of clean covered."
        />
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit,minmax(240px,1fr))",
            gap: 28,
            maxWidth: 1100,
            margin: "0 auto",
          }}
        >
          {SERVICES.map((s) => (
            <div
              key={s.title}
              style={{
                borderRadius: 20,
                padding: 32,
                border: `1px solid ${s.color}22`,
                background: `${s.color}08`,
                transition: "transform .2s, box-shadow .2s",
                cursor: "default",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = "translateY(-6px)";
                e.currentTarget.style.boxShadow = `0 20px 40px ${s.color}25`;
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = "none";
                e.currentTarget.style.boxShadow = "none";
              }}
            >
              <div style={{ fontSize: 40, marginBottom: 16 }}>{s.icon}</div>
              <h3
                style={{
                  fontWeight: 800,
                  fontSize: 20,
                  marginBottom: 10,
                  color: s.color,
                }}
              >
                {s.title}
              </h3>
              <p
                style={{
                  color: "#64748B",
                  lineHeight: 1.6,
                  marginBottom: 16,
                  fontSize: 14,
                }}
              >
                {s.desc}
              </p>
              <div
                style={{
                  display: "inline-flex",
                  alignItems: "center",
                  gap: 6,
                  background: `${s.color}15`,
                  borderRadius: 50,
                  padding: "4px 12px",
                  fontSize: 13,
                  fontWeight: 600,
                  color: s.color,
                }}
              >
                ⏱ {s.time}
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* ── PLANS ── */}
      {/* <section id="plans" style={{ padding: "100px 5%", background: "linear-gradient(135deg,#F8FAFC,#F1F5F9)" }}>
        <SectionHeader label="Pricing Plans" title="Flexible Plans for Every Driver" sub="On-demand or subscription — choose what fits your lifestyle and save more." />
        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit,minmax(240px,1fr))", gap: 28, maxWidth: 1100, margin: "0 auto" }}>
          {PLANS.map(p => (
            <div key={p.name} style={{
              borderRadius: 24, padding: 32, background: "#fff",
              boxShadow: "0 4px 24px rgba(0,0,0,0.07)", position: "relative",
              border: `2px solid ${p.badge ? p.color : "transparent"}`,
              transition: "transform .2s, box-shadow .2s",
            }}
              onMouseEnter={e => { e.currentTarget.style.transform = "translateY(-6px)"; e.currentTarget.style.boxShadow = `0 20px 40px ${p.color}25`; }}
              onMouseLeave={e => { e.currentTarget.style.transform = "none"; e.currentTarget.style.boxShadow = "0 4px 24px rgba(0,0,0,0.07)"; }}
            >
              {p.badge && (
                <div style={{
                  position: "absolute", top: -14, left: "50%", transform: "translateX(-50%)",
                  background: `linear-gradient(135deg,${p.color},${p.color}cc)`,
                  color: "#fff", borderRadius: 50, padding: "4px 16px", fontSize: 12, fontWeight: 700, whiteSpace: "nowrap",
                }}>{p.badge}</div>
              )}
              <div style={{ fontSize: 36, marginBottom: 12 }}>{p.icon}</div>
              <h3 style={{ fontWeight: 800, fontSize: 20, marginBottom: 4 }}>{p.name}</h3>
              <div style={{ marginBottom: 20 }}>
                <span style={{ fontSize: 36, fontWeight: 900, color: p.color }}>{p.price}</span>
                <span style={{ color: "#94A3B8", fontSize: 14, marginLeft: 4 }}>{p.unit}</span>
              </div>
              <ul style={{ listStyle: "none", padding: 0, margin: "0 0 24px", display: "flex", flexDirection: "column", gap: 10 }}>
                {p.features.map(f => (
                  <li key={f} style={{ display: "flex", alignItems: "center", gap: 10, fontSize: 14, color: "#475569" }}>
                    <span style={{ color: p.color, fontWeight: 700 }}>✓</span> {f}
                  </li>
                ))}
              </ul>
              <button style={{
                width: "100%", padding: "12px 0", borderRadius: 12, border: "none", cursor: "pointer",
                background: p.badge ? `linear-gradient(135deg,${p.color},${p.color}bb)` : `${p.color}15`,
                color: p.badge ? "#fff" : p.color, fontWeight: 700, fontSize: 15,
                transition: "opacity .2s",
              }}
                onMouseEnter={e => e.currentTarget.style.opacity = ".85"}
                onMouseLeave={e => e.currentTarget.style.opacity = "1"}
              >
                Download App to Subscribe
              </button>
            </div>
          ))}
        </div>
      </section> */}

      {/* ── HOW IT WORKS ── */}
      <section
        id="how-it-works"
        style={{ padding: "100px 5%", background: "#fff" }}
      >
        <SectionHeader
          label="How It Works"
          title="Get a Shiny Car in 5 Easy Steps"
          sub="Our streamlined process makes booking a car wash easier than ever."
        />
        <div
          style={{
            maxWidth: 900,
            margin: "0 auto",
            display: "flex",
            flexDirection: "column",
            gap: 0,
          }}
        >
          {STEPS.map((s, i) => (
            <div
              key={s.step}
              style={{
                display: "flex",
                gap: 24,
                alignItems: "flex-start",
                position: "relative",
              }}
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                }}
              >
                <div
                  style={{
                    width: 56,
                    height: 56,
                    borderRadius: "50%",
                    minWidth: 56,
                    background: "linear-gradient(135deg,#3B82F6,#8B5CF6)",
                    color: "#fff",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontWeight: 800,
                    fontSize: 18,
                    boxShadow: "0 4px 16px rgba(59,130,246,.3)",
                  }}
                >
                  {s.step}
                </div>
                {i < STEPS.length - 1 && (
                  <div
                    style={{
                      width: 2,
                      flex: 1,
                      minHeight: 40,
                      background: "linear-gradient(#3B82F6,#8B5CF6)",
                      margin: "4px 0",
                    }}
                  />
                )}
              </div>
              <div style={{ paddingBottom: 40 }}>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 10,
                    marginBottom: 6,
                  }}
                >
                  <span style={{ fontSize: 24 }}>{s.icon}</span>
                  <h3 style={{ fontWeight: 800, fontSize: 18 }}>{s.title}</h3>
                </div>
                <p style={{ color: "#64748B", lineHeight: 1.7, margin: 0 }}>
                  {s.desc}
                </p>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* ── TESTIMONIALS ── */}
      <section
        style={{
          padding: "80px 5%",
          background: "linear-gradient(135deg,#EFF6FF,#F5F3FF)",
        }}
      >
        <SectionHeader
          label="Reviews"
          title="What Our Customers Say"
          sub="Thousands of happy car owners trust ShineDrive."
        />
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit,minmax(260px,1fr))",
            gap: 24,
            maxWidth: 1000,
            margin: "0 auto",
          }}
        >
          {TESTIMONIALS.map((t) => (
            <div
              key={t.name}
              style={{
                background: "#fff",
                borderRadius: 20,
                padding: 28,
                boxShadow: "0 4px 20px rgba(0,0,0,0.06)",
              }}
            >
              <div style={{ color: "#F59E0B", fontSize: 18, marginBottom: 12 }}>
                {"★".repeat(t.rating)}
              </div>
              <p
                style={{
                  color: "#475569",
                  lineHeight: 1.7,
                  marginBottom: 16,
                  fontStyle: "italic",
                }}
              >
                "{t.text}"
              </p>
              <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
                <div
                  style={{
                    width: 40,
                    height: 40,
                    borderRadius: "50%",
                    background: "linear-gradient(135deg,#3B82F6,#8B5CF6)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    color: "#fff",
                    fontWeight: 700,
                  }}
                >
                  {t.name[0]}
                </div>
                <div>
                  <div style={{ fontWeight: 700, fontSize: 14 }}>{t.name}</div>
                  <div style={{ color: "#94A3B8", fontSize: 12 }}>{t.city}</div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* ── APP DOWNLOAD BANNER ── */}
      <section
        style={{
          padding: "80px 5%",
          textAlign: "center",
          background: "linear-gradient(135deg,#3B82F6,#8B5CF6)",
          color: "#fff",
        }}
      >
        <div style={{ fontSize: 48, marginBottom: 16 }}>📱</div>
        <h2
          style={{
            fontSize: "clamp(26px,4vw,44px)",
            fontWeight: 900,
            marginBottom: 12,
          }}
        >
          Ready to Book Your Wash?
        </h2>
        <p
          style={{
            fontSize: 16,
            opacity: 0.85,
            marginBottom: 36,
            maxWidth: 480,
            margin: "0 auto 36px",
          }}
        >
          Download the ShineDrive app, pick your plan, and get a spotless car
          delivered to your doorstep.
        </p>
        <div
          style={{
            display: "flex",
            gap: 16,
            justifyContent: "center",
            flexWrap: "wrap",
          }}
        >
          <StoreButton store="google" dark />
          <StoreButton store="apple" dark />
        </div>
      </section>

      {/* ── CONTACT ── */}
      <section
        id="contact"
        style={{ padding: "80px 5%", background: "#F8FAFC" }}
      >
        <SectionHeader
          label="Contact Us"
          title="We'd Love to Hear From You"
          sub="Have questions? Reach out and our team will get back to you promptly."
        />
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit,minmax(200px,1fr))",
            gap: 24,
            maxWidth: 800,
            margin: "0 auto",
          }}
        >
          {[
            { icon: "📞", title: "Phone", val: "+91 76009 37691" },
            { icon: "📧", title: "Email", val: "manoj.cleanup@gmail.com" },
            { icon: "📍", title: "HQ", val: "Ahmedabad, Gujarat, India" },
            // { icon: "🕐", title: "Hours", val: "7 AM – 9 PM, Daily" },
          ].map((c) => (
            <div
              key={c.title}
              style={{
                background: "#fff",
                borderRadius: 16,
                padding: 28,
                boxShadow: "0 2px 12px rgba(0,0,0,0.06)",
                textAlign: "center",
              }}
            >
              <div style={{ fontSize: 32, marginBottom: 10 }}>{c.icon}</div>
              <div style={{ fontWeight: 700, marginBottom: 4 }}>{c.title}</div>
              <div style={{ color: "#64748B", fontSize: 14 }}>{c.val}</div>
            </div>
          ))}
        </div>
      </section>
      <div style={{ textAlign: "center", paddingTop: "80px" }}>
        {/* First Section */}
        {!showDeleteInfo && (
          <div style={{ marginBottom: "80px" }}>
            <h1 style={{ fontWeight: "600", marginBottom: "20px" }}>
              Delete Account
            </h1>

            <p style={{ fontSize: "16px" }}>
              If you want delete your account{" "}
              <span
                onClick={handleDeleteClick}
                style={{
                  color: "orange",
                  cursor: "pointer",
                  fontWeight: "500",
                }}
              >
                click here
              </span>{" "}
              for delete your account
            </p>
          </div>
        )}

        {/* Second Section (After Click) */}
        {showDeleteInfo && (
          <div>
            <h1 style={{ fontWeight: "600", marginBottom: "20px" }}>
              Delete Your Account
            </h1>

            <p style={{ fontSize: "16px" }}>
              If you want to delete your account, please mail with your
              registred email id at <b>manoj.cleanup@gmail.com</b>
            </p>
          </div>
        )}
      </div>
      {/* ── FOOTER ── */}
      <footer
        style={{
          background: "#0F172A",
          color: "#94A3B8",
          padding: "48px 5% 28px",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            flexWrap: "wrap",
            gap: 32,
            marginBottom: 40,
          }}
        >
          <div style={{ maxWidth: 280 }}>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: 10,
                marginBottom: 12,
              }}
            >
              <div
                style={{
                  width: 36,
                  height: 36,
                  borderRadius: 8,
                  background: "linear-gradient(135deg,#3B82F6,#8B5CF6)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontSize: 18,
                }}
              >
                🚿
              </div>
              <span style={{ fontWeight: 800, fontSize: 18, color: "#fff" }}>
                ShineDrive
              </span>
            </div>
            <p style={{ fontSize: 14, lineHeight: 1.7 }}>
              Professional doorstep car wash services. Clean car, happy you —
              every time.
            </p>
          </div>
          <div>
            <div style={{ color: "#fff", fontWeight: 700, marginBottom: 14 }}>
              Services
            </div>
            {[
              "Quick Wash",
              "Deep Clean",
              "Premium Detail",
              "Glass & Tyre Care",
            ].map((s) => (
              <div
                key={s}
                style={{ marginBottom: 8, fontSize: 14, cursor: "pointer" }}
                onMouseEnter={(e) => (e.target.style.color = "#fff")}
                onMouseLeave={(e) => (e.target.style.color = "#94A3B8")}
              >
                {s}
              </div>
            ))}
          </div>
          <div>
            <div style={{ color: "#fff", fontWeight: 700, marginBottom: 14 }}>
              Company
            </div>
            {["About Us", "How It Works", "Pricing", "Blog", "Careers"].map(
              (s) => (
                <div
                  key={s}
                  style={{ marginBottom: 8, fontSize: 14, cursor: "pointer" }}
                  onMouseEnter={(e) => (e.target.style.color = "#fff")}
                  onMouseLeave={(e) => (e.target.style.color = "#94A3B8")}
                >
                  {s}
                </div>
              ),
            )}
          </div>
          <div>
            <div style={{ color: "#fff", fontWeight: 700, marginBottom: 14 }}>
              Download App
            </div>
            <StoreButton store="google" footer />
            <div style={{ height: 10 }} />
            <StoreButton store="apple" footer />
          </div>
        </div>
        <div
          style={{
            borderTop: "1px solid #1E293B",
            paddingTop: 24,
            display: "flex",
            justifyContent: "space-between",
            flexWrap: "wrap",
            gap: 12,
            fontSize: 13,
          }}
        >
          <span>© 2025 ShineDrive. All rights reserved.</span>
          <div style={{ display: "flex", gap: 20 }}>
            <span
              style={{ cursor: "pointer" }}
              onClick={() => window.open("/terms-of-service", "_blank")}
            >
              Terms of Service
            </span>

            <span
              style={{ cursor: "pointer" }}
              onClick={() => window.open("/privacy-policy", "_blank")}
            >
              Privacy Policy
            </span>
            <span
              style={{ cursor: "pointer" }}
              // onClick={() => window.open("/privacy-policy", "_blank")}
            >
              Cookie Policy
            </span>
          </div>
        </div>
      </footer>
    </div>
  );
}

function SectionHeader({ label, title, sub }) {
  return (
    <div style={{ textAlign: "center", marginBottom: 60 }}>
      <div
        style={{
          display: "inline-block",
          background: "linear-gradient(135deg,#EFF6FF,#F5F3FF)",
          color: "#3B82F6",
          fontWeight: 700,
          fontSize: 13,
          letterSpacing: 1.5,
          textTransform: "uppercase",
          borderRadius: 50,
          padding: "6px 18px",
          marginBottom: 16,
          border: "1px solid #BFDBFE",
        }}
      >
        {label}
      </div>
      <h2
        style={{
          fontSize: "clamp(26px,4vw,44px)",
          fontWeight: 900,
          marginBottom: 14,
          lineHeight: 1.2,
        }}
      >
        {title}
      </h2>
      <p
        style={{
          color: "#64748B",
          fontSize: 16,
          maxWidth: 520,
          margin: "0 auto",
          lineHeight: 1.7,
        }}
      >
        {sub}
      </p>
    </div>
  );
}

function StoreButton({ store, dark, footer }) {
  const isGoogle = store === "google";
  const base = {
    display: "inline-flex",
    alignItems: "center",
    gap: 10,
    padding: footer ? "10px 16px" : "14px 24px",
    borderRadius: 12,
    border: dark ? "2px solid rgba(255,255,255,0.3)" : "2px solid #E2E8F0",
    background: dark ? "rgba(255,255,255,0.12)" : "#fff",
    color: dark ? "#fff" : "#1E293B",
    cursor: "pointer",
    textDecoration: "none",
    transition: "all .2s",
    minWidth: footer ? "auto" : 180,
  };
  return (
    <div
      style={base}
      onMouseEnter={(e) => {
        e.currentTarget.style.background = dark
          ? "rgba(255,255,255,0.22)"
          : "#F8FAFC";
        e.currentTarget.style.transform = "translateY(-2px)";
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.background = dark
          ? "rgba(255,255,255,0.12)"
          : "#fff";
        e.currentTarget.style.transform = "none";
      }}
    >
      <span style={{ fontSize: footer ? 20 : 26 }}>{isGoogle ? "▶" : ""}</span>
      <div>
        <div style={{ fontSize: 10, opacity: 0.7, lineHeight: 1 }}>
          {isGoogle ? "GET IT ON" : "Download on the"}
        </div>
        <div style={{ fontWeight: 800, fontSize: footer ? 13 : 16 }}>
          {isGoogle ? "Google Play" : "App Store"}
        </div>
      </div>
    </div>
  );
}
